<template>
  <div class="xcard">
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
    <h3 class="text-primary text-center">
      Listado de Facturas por NIT
    </h3>

    <div class="row" style="background:#E9F2F7;">
      <div class="col-sm-12">
        <p class="ma-0 pa-0">
          Para buscar las facturas debe seleccionar la gestion, el mes, y el nit, al seleccionar un nit automaticamente
          se procede a buscar las facturas, puede descargar las facturas en formato excel y en un formato para exportar
          a facilito.
        </p>
      </div>
      <div class="col-sm-2 col-lg-1">
        <select class="form-control" v-model="gestion">
          <option v-for="(p, ind) in gestiones" :key="ind" :value="p"> {{ p }} </option>
        </select>
        <small>Gestion</small>
      </div>
      <div class="col-sm-2">
        <select class="form-control" v-model="mes">
          <option v-for="(p, ind) in meses" :key="ind" :value="p.id"> {{ p.mes }} </option>
        </select>
        <small>Mes</small>
      </div>
      <div class="col-sm-5 col-lg-6">
        <select class="form-control" v-model="nicsel" :disabled="!gestion || !mes">
          <option v-for="(p, ind) in nics" :key="ind" :value="p"> {{ p }} </option>
        </select>
        <small>Seleccione un Nit</small>
      </div>

      <!-- <div class="col-sm-2">
                <button class="btn btn-sm btn-azul"><span class="glyphicon glyphicon-search"></span> Buscar</button>
            </div> -->
    </div>

    <div class="table-responsive">
      <input
        v-show="facturas.length"
        type="text"
        style="border:1px solid #1177d1;background:#fefefe"
        v-model="buscar"
        placeholder="Buscar..."
      />
      <table ref="table" class="table table-hover table-condensed" id="midatatable">
        <thead style="background:#196391;">
          <tr class="white--text">
            <th>#</th>
            <th>No. factura</th>
            <th>Nit empresa</th>
            <th>Nit cliente</th>
            <th>Cliente</th>
            <th>Imp. total</th>
            <th>No. Auth</th>
            <th>Estado</th>
            <th>Opciones</th>
          </tr>
        </thead>

        <tbody>
          <tr
            v-bind:key="ind"
            v-for="(fact, ind) in facturas"
            :style="fact.estado == 'ANULADA' ? 'background:#FCCDCD' : ''"
          >
            <td>{{ ind + 1 }}</td>
            <td>{{ fact.numero_factura }}</td>
            <td>{{ fact.nit_empresa }}</td>
            <td>{{ fact.nit_cliente }}</td>
            <td>{{ fact.nombre_cliente }}</td>
            <td>{{ fact.importe_total_venta }}</td>
            <td>{{ fact.numero_autorizacion }}</td>
            <td>{{ fact.estado }}</td>
            <td>
              <v-menu left open-on-hover :close-on-content-click="false" offset-x tile>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="mt-0 pa-0" small color="primary" icon dark v-bind="attrs" v-on="on">
                    <v-icon small>mdi-eye</v-icon>
                  </v-btn>
                </template>

                <div class="bg-primary pa-4" style="background:#196391">
                  <h3 class="text-center white--text mt-0">Detalle de la factura</h3>
                  <hr class="ma-0 blue darken-2" />
                  <v-row class="mb-2">
                    <v-col>
                      <p class="mb-1 mt-0"><b>Especificacion:</b> {{ fact.especificacion }}</p>
                      <!-- <p class="mb-1 mt-0"><b>Nro:</b> {{ fact.nro }}</p> -->
                      <p class="mb-1 mt-0"><b>Fecha:</b> {{ fact.fecha }}</p>
                      <p class="mb-1 mt-0"><b>Fecha limite emision:</b> {{ fact.fecha_limite_emision }}</p>
                      <p class="mb-1 mt-0"><b>Fecha registro:</b> {{ fact.fecha_registro }}</p>
                      <p class="mb-1 mt-0"><b>Hora:</b> {{ fact.hora }}</p>
                    </v-col>
                    <v-col>
                      <p class="mb-1 mt-0"><b>Nro factura:</b> {{ fact.numero_factura }}</p>
                      <p class="mb-1 mt-0"><b>Nro autorizacion:</b> {{ fact.numero_autorizacion }}</p>
                      <p class="mb-1 mt-0"><b>estado:</b> {{ fact.estado }}</p>
                      <p class="mb-1 mt-0"><b>Nit cliente:</b> {{ fact.nit_cliente }}</p>
                      <p class="mb-1 mt-0"><b>Nit empresa:</b> {{ fact.nit_empresa }}</p>
                      <p class="mb-1 mt-0"><b>Razon social:</b> {{ fact.razon_social }}</p>
                      <p class="mb-1 mt-0"><b>Importe total venta:</b> {{ fact.importe_total_venta }}</p>
                      <p class="mb-1 mt-0"><b>Importe iva:</b> {{ fact.importe_iva }}</p>
                      <p class="mb-1 mt-0"><b>Exportaciones:</b> {{ fact.exportaciones }}</p>
                    </v-col>
                    <v-col>
                      <p class="mb-1 mt-0"><b>Ventas tasa cero:</b> {{ fact.ventas_tasa_cero }}</p>
                      <p class="mb-1 mt-0"><b>Subtotal:</b> {{ fact.subtotal }}</p>
                      <p class="mb-1 mt-0"><b>Descuentos iva:</b> {{ fact.descuentos_iva }}</p>
                      <p class="mb-1 mt-0"><b>Importe fiscal:</b> {{ fact.importe_fiscal }}</p>
                      <p class="mb-1 mt-0"><b>Debito fiscal:</b> {{ fact.debito_fiscal }}</p>
                      <p class="mb-1 mt-0"><b>Codigo control:</b> {{ fact.codigo_control }}</p>
                    </v-col>
                  </v-row>
                  <hr class="ma-0 blue darken-2" />
                </div>
              </v-menu>
            </td>
          </tr>
        </tbody>
      </table>

      <p class="text-center red--text">
        {{ msg }}
      </p>

      <div class="text-center">
        <div style="display: inline-block;" v-show="loading" class="loader"></div>
      </div>

      <FacturasDownload :facturas="facturas" :datosdescarga="datosdescargas" />
    </div>
  </div>
</template>

<script>
  import FacturasDownload from '@/components/facturastoexcel.vue';
  import { getheadersrest } from '@/components/Utils';
  import gql from 'graphql-tag';
  import xaxios from '@/xaxios';

  export default {
    data() {
      return {
        api_rest: process.env.VUE_APP_API_REST,
        sede: null,
        msg: '',
        loading: false,
        datosdescargas: {},
        seleccionado: {},
        sucursales: [],
        facturasall: [],
        facturas: [],
        nicsel: {},
        nits: [],
        nics: [],
        busqueda: {
          fecha_ini: null,
          fecha_fin: null,
        },
        mes: null,
        gestion: null,
        meses: [
          { id: 1, mes: 'Enero' },
          { id: 2, mes: 'Febrero' },
          { id: 3, mes: 'Marzo' },
          { id: 4, mes: 'Abril' },
          { id: 5, mes: 'Mayo' },
          { id: 6, mes: 'Junio' },
          { id: 7, mes: 'Julio' },
          { id: 8, mes: 'Agosto' },
          { id: 9, mes: 'Septiembre' },
          { id: 10, mes: 'Octubre' },
          { id: 11, mes: 'Noviembre' },
          { id: 12, mes: 'Diciembre' },
        ],
        gestiones: [2024,2023, 2022, 2021, 2020 /*2019, 2018, 2017*/],
        buscar: '',
      };
    },
    components: { FacturasDownload },
    watch: {
      buscar: function() {
        this.myFunction1(this.buscar.trim());
      },
      '$store.state.CARGO': function() {
        this.sede = this.$store.state.CARGO.idsede;
        this.getSucursales(this.sede);
        this.nicsel = null;
        this.facturas = [];
        window.console.log(this.$store.state.CARGO);
      },
      gestion: function() {
        this.facturas = [];
        this.nicsel = null;
      },
      mes: function() {
        this.facturas = [];
        this.nicsel = null;
      },
      nicsel: function() {
        if (!this.nicsel) return;
        // NIT-idsucursal-anio-mes.xlsx
        let m = this.meses.find((x) => x.id == this.mes).mes;
        //let nit = this.nits.find( x=> x.id == this.sucursal.nit_id );
        let filename = `${this.nicsel}-${this.gestion}-${m}`;
        this.datosdescargas.filename = filename;
        this.facturas = [];
        //this.getDatos();
        this.getDatosFacturas();
      },
    },
    methods: {
      editar(obj) {
        this.seleccionado = obj;
      },
      modalExitof() {
        //this.getDatos();
      },
      parsesede(s) {
        if (!s) return;
        let guion = s.indexOf('-') + 2;
        let str = s.substring(guion, s.length);
        return str;
      },
      async getDatos(datosserver) {
        const vue = this;
        datosserver.sort(function(a, b) {
          return a.numero_autorizacion - b.numero_autorizacion || a.numero_factura - b.numero_factura;
        });
        /*
        {
        "id": 6934,
        "emisor_id": 14076,
        "sucursal_id": 12,
        "numero_factura": 266,
        "nit_cliente": "3697305",
        "nombre_cliente": "Carreño Mallcu Judith",
        "nit_empresa": 380096028,
        "numero_autorizacion": 434401100070395,
        "fecha": "2021-09-01",
        "fecha_limite_emision": "2022-01-02",
        "hora": "00:00:44",
        "qr": "380096028|266|434401100070395|01/09/2021|801.00|801.00|FA-38-07-A2-72|3697305|0|0|0|0",
        "codigo_control": "C7-06-7E-BD-21",
        "monto": "801.00",
        "debito_fiscal": 104.13,
        "primera_linea": "PROHIBIDA SU EMISIÓN PARA ESPECTÁCULO PÚBLICO EVENTUAL",
        "segunda_linea": "Ley N° 453: Los servicios deben suministrarse en condiciones de inocuidad, calidad y seguridad.",
        "actividad": "ENSEÑANZA SUPERIOR",
        "impreso": true,
        "fecha_registro": "2021-09-01 00:00:44",
        "estado": "VALIDA",
        "detalle": [
            {
                "id": 9293,
                "concepto": "Colegiatura - 2",
                "monto": 801,
                "factura_id": 6934
            }
        ]
    },
        */
        window.console.log('FACTURAS:\n', datosserver);
        datosserver.forEach(function(dem) {
          let fs = dem.fecha.split('-');
          /*let xmonto = 0;
          dem.detalle.forEach((x) => {
            xmonto += x.monto;
          });*/
          //dem.importe_total_venta = xmonto.toFixed(2);
          dem.importe_total_venta = dem.monto;
          dem.especificacion = 3;
          dem.importe_iva = 0;
          dem.exportaciones = 0;
          dem.ventas_tasa_cero = 0;
          dem.subtotal = dem.monto;
          dem.descuentos_iva = 0;
          dem.importe_fiscal = dem.monto;
          //dem.debito_fiscal = (xmonto * 0.13).toFixed(2);
          dem.fecha_slash = `${fs[2]}/${fs[1]}/${fs[0]}`;
          dem.nombre_cliente = dem.nombre_cliente.toUpperCase();
          vue.facturasall.push(dem);
          //window.console.log(vue.nicsel, dem.nit_empresa)
          if (vue.nicsel == dem.nit_empresa) {
            dem.nro = vue.facturas.length + 1;
            vue.facturas.push(dem);
          }
        });
      },
      async getSucursales(idsede) {
        this.sucursales = await xaxios
          .post(`${this.api_rest}/esam/sucursales`, { sede_id: idsede })
          .then(({ data }) => (data ? data : []))
          .catch(() => [{ id: 1, ciudad_nit: 'Tarija - 123456789', ciudad: 'Tarija' }]);
        window.console.log('SUCURSALES: ', this.sucursales);
      },
      getfechasrango() {
        let date_inicio = new Date();
        date_inicio.setDate(1);
        date_inicio.setFullYear(this.gestion);
        date_inicio.setMonth(this.mes - 1);
        let date_final = new Date();
        date_final.setDate(1);
        date_final.setMonth(date_inicio.getMonth() + 1);
        date_final.setFullYear(date_inicio.getFullYear());
        date_final.setDate(date_final.getDate() - 1);
        let d1 = '01';
        let m1 = date_inicio.getMonth() + 1;
        let y1 = date_inicio.getFullYear();
        let d2 = date_final.getDate();
        let m2 = date_final.getMonth() + 1;
        let y2 = date_final.getFullYear();
        if (m1 < 10) m1 = '0' + m1;
        if (d2 < 10) d2 = '0' + d2;
        //d2 = '05';
        if (m2 < 10) m2 = '0' + m2;
        let fechas = `&fecha_inicio=${d1}/${m1}/${y1}&fecha_fin=${d2}/${m2}/${y2}`;
        //window.console.log(fechas);
        return fechas;
      },
      getDatosFacturas() {
        const vue = this;
        vue.loading = true;
        vue.msg = '';
        let myHeaders = getheadersrest(); // sucuesal id ??
        //let url = `${this.api_rest}/api/pagos/facturas?sucursal_id=1${this.getfechasrango()}&estado=V`;
        let url = `${this.api_rest}/api/pagos/facturas?nit_empresa=${this.nicsel}${this.getfechasrango()}`;
        let requestOptions = { method: 'GET', headers: myHeaders };
        window.console.log(myHeaders, url);

        fetch(url, requestOptions)
          .then((response) => response.json())
          .then((result) => {
            if (!result) result = [];
            vue.getDatos(result);
            //window.console.log('FACTURAS:\n', result);
            vue.loading = false;
            if (vue.facturas.length == 0) {
              vue.msg = 'No se han encontrado facturas segun los datos de busqueda ingresados.';
            }
          })
          .catch((err) => {
            vue.loading = false;
            window.console.log(err);
          });
      },
      myFunction1(filtro) {
        filtro = filtro.toUpperCase();
        var table, tr, tdd, td, i, j, txtValue;
        table = document.getElementById('midatatable');
        tr = table.getElementsByTagName('tr');

        for (i = 0; i < tr.length; i++) {
          tdd = tr[i].getElementsByTagName('td');
          for (j = 1; j < tdd.length; j++) {
            td = tdd[j];
            if (td) {
              txtValue = td.textContent;
              if (txtValue.toUpperCase().indexOf(filtro) > -1) {
                tr[i].style.display = '';
                break;
              } else {
                tr[i].style.display = 'none';
              }
            }
          }
        }
      },

      parseDatosForExcel(datos) {
        datos.forEach((x, i) => {
          let dato = {
            especificacion: '3',
            nro: i + 1,
            fecha_factura: '',
            nro_factura: '',
            nro_autorizacion: '',
            estado: '',
            nit_cliente: '',
            razon_social: '',
            importe_total_venta: '',
            importe_iva: '',
            exportaciones: '',
            ventas_tasa_cero: '',
            subtotal: '',
            descuentos_iva: '',
            importe_fiscal: '',
            debito_fiscal: '',
            codigo_control: '',
          };
          window.console.log(dato);
        });
      },
      getsucursalesall() {
        const vue = this;
        vue.nics = [];
        let qs = gql`
          query {
            getSucursales {
              id
              nit_id
              direccion
              telefono
              ciudad
              numero_sucursal
            }
            getNits {
              id
              nombre
              descripcion
              nro
              estado
            }
          }
        `;
        this.$apollo
          .query({
            query: qs,
          })
          .then((data) => {
            if (!data.data.getSucursales) data.data.getSucursales = [];
            window.console.log('sucursales: ', data.data);
            vue.sucursales = data.data.getSucursales;
            vue.nits = data.data.getNits;
            vue.nits.forEach((x) => {
              vue.nics.push(x.nro);
            });
            let sucbysedes = vue.sucursales/*.filter((x) => {
              return x.sede_id == vue.sede;
            })*/;
            window.console.log('NITS: ', vue.nits);
            window.console.log('SUCURALES: ', vue.sucursales, sucbysedes);
          })
          .catch((error) => {
            window.console.error(error);
          });
      },
    },
    mounted() {
      let anio = new Date().getFullYear();
      this.gestion = anio;
      this.getsucursalesall();
      this.sede = this.$store.state.CARGO.idsede;
    },
  };
</script>
